import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { queryClient } from '@/api/react-query'
import { applicationQueryKey } from '@/api/financial/application/read-application'

export type ApplicationPersonType =
  | 'student'
  | 'financial_responsible'
  | 'guarantor'

export type NewApplicationPerson = {
  name: string
  tax_id: string
  birthdate: string
  email: string
  phone: string
  types: ApplicationPersonType[]
  relationship: string | null
}

function invalidate(applicationKey: string) {
  queryClient.invalidateQueries({
    queryKey: applicationQueryKey(applicationKey),
  })
}

/** Cria a pessoa (ou reaproveita a do mesmo CPF) já vinculada à solicitação. */
export function useCreateApplicationPerson(applicationKey: string) {
  return useMutation({
    mutationFn: async (body: NewApplicationPerson) => {
      const response = await httpClient('financial').post<{ key: string }>(
        `/v1/person/${applicationKey}`,
        { ...body, tax_id_type: 'cpf' },
      )
      return response.data
    },
    onSuccess: () => invalidate(applicationKey),
  })
}

export function useSetApplicationPersonTypes(applicationKey: string) {
  return useMutation({
    mutationFn: async ({
      personKey,
      types,
      relationship,
    }: {
      personKey: string
      types: ApplicationPersonType[]
      relationship?: string | null
    }) => {
      await httpClient('financial').put(
        `/v1/application/${applicationKey}/person/${personKey}`,
        { types, relationship },
      )
    },
    onSuccess: () => invalidate(applicationKey),
  })
}

export function useDetachApplicationPerson(applicationKey: string) {
  return useMutation({
    mutationFn: async (personKey: string) => {
      await httpClient('financial').delete(
        `/v1/application/${applicationKey}/person/${personKey}/detach`,
      )
    },
    onSuccess: () => invalidate(applicationKey),
  })
}
